import {AssetDetailsComponent} from "src/app/presentation/common/asset-details.component";
import {Asset, FixedAsset} from "src/app/infrastructure/moovement-api/models/asset";
import {Subject, takeUntil} from "rxjs";
import {Component, inject} from "@angular/core";
import {NavBarStateStore} from "src/app/presentation/main-view/nav-bar/nav-bar-state/nav-bar-state.store";
import {
  dropAPinMessage,
  InternalNotification,
  InternalNotificationsStore,
  InternalNotificationType
} from "src/app/infrastructure/internal-notifications/internal-notifications.store";

@Component({
  template: ``,
  standalone: false
})
export abstract class CustomizableAssetComponent<A extends Asset> extends AssetDetailsComponent<A> {

  private $destroyDropAPin: Subject<void> = new Subject<void>()
  private dropAPinNotification?: InternalNotification;

  internalNotificationsStore = inject(InternalNotificationsStore);

  private menuStore = inject(NavBarStateStore);

  abstract applyChanges(): void

  onDropAPin() {
    this.menuStore.disable();
    this.dropAPinNotification = this.internalNotificationsStore.addNotification(dropAPinMessage, InternalNotificationType.INFO, true);
    this.dataSubscriptionService.publish('dropAPin', true)
    this.dataSubscriptionService.onFirst<{
      lng: number,
      lat: number
    }>('currentPosition').pipe(takeUntil(this.$destroyDropAPin)).subscribe({
      next: data => {
        if (confirm(this.confirmDropAPinMessage())) {
          this.asset.update(asset => {
            if (!asset) return undefined;

            return {
              ...asset,
              location: {
                ...(asset as FixedAsset)?.location,
                coords: [data.lat, data.lng]
              }
            }
          });
          this.applyChanges()
        }
        this.reset();
      }
    });
    this.mainViewStore.hideChildComponent();
  }

  protected abstract confirmDropAPinMessage(): string;

  private reset() {
    this.menuStore.enable();
    this.dataSubscriptionService.publish('currentPosition');
    this.$destroyDropAPin.complete();
    this.$destroyDropAPin = new Subject<void>();
    if (this.dropAPinNotification) this.internalNotificationsStore.deleteNotification(this.dropAPinNotification);
    this.dataSubscriptionService.publish('dropAPin', false);
    this.mainViewStore.showChildComponent();
  }
}
